// extracted by mini-css-extract-plugin
module.exports = {"login-form-title":"register-en_login-form-title__pTxeu","login-form-sub-title":"register-en_login-form-sub-title__nfsXw"};